import {toggle_loader, disable_loader} from '../../theme/_loader';

document.addEventListener("DOMContentLoaded", function() {

    function toggle_search_sidebar(option = 'refine') {

        //fetch the requested sidebar and button
        let sidebar = document.getElementById(option + '-sidebar');
        let button = document.getElementById('open-' + option + '-sidebar');

        //detect whether one of our sidebars is currently open
        let currently_open = document.body.getAttribute('data-sidebar-open');

        //if a sidebar is open but it's not the one we're interacting with now
        if(currently_open && currently_open != option) {

            //close the other sidebar
            document.getElementById(currently_open + '-sidebar').classList.remove('active');
            document.getElementById('open-' + currently_open + '-sidebar').classList.remove('active');
        }

        //if the sidebar is already open...
        if(sidebar.classList.contains('active')) {

            //close the sidebar, toggle button state and removed our overflow hidden
            sidebar.classList.remove('active');
            button.classList.remove('active');
            document.body.classList.remove('overflow-y-hidden');

            //remove our data attribute
            document.body.removeAttribute('data-sidebar-open');
        } else { //otherwise, we're opening it...

            //open the sidebar, toggle button state and add our overflow hidden
            sidebar.classList.add('active');
            button.classList.add('active');
            document.body.classList.add('overflow-y-hidden');

            //add our data attribute
            document.body.setAttribute('data-sidebar-open', option);
        }
    }

    function removeURLParameters(removeParams) {
		const deleteRegex = new RegExp(removeParams.join('=|') + '=')

		const params = location.search.slice(1).split('&')
		let search = []
		for (let i = 0; i < params.length; i++) if (deleteRegex.test(params[i]) === false) search.push(params[i])

		window.history.replaceState({}, document.title, location.pathname + (search.length ? '?' + search.join('&') : '') + location.hash)
    }

	document.addEventListener('click', function (event) {

		//if the clicked element is a toggle for the sidebar
		if(event.target.matches('#refine-sidebar') || event.target.matches('#open-refine-sidebar')) {
			toggle_search_sidebar();
		}

		//if the clicked element is a toggle for the sidebar
		if(event.target.matches('#purchase-sidebar') || event.target.matches('#open-purchase-sidebar')) {
			toggle_search_sidebar('purchase');
		}
	});

	document.addEventListener('keydown', function(event) {

		//if the escape key has been pressed...
		if(event.code == "Escape" || event.code == "Esc") {

            //if the refine sidebar is open...
            if(document.querySelector('#refine-sidebar').classList.contains('active')) {

                //close it
                toggle_search_sidebar();
            } else if(document.querySelector('#purchase-sidebar').classList.contains('active')) { //otherwise if the purchase sidebar is open...

                //close it
                toggle_search_sidebar('purchase');
            }
		}
	}, false);

	document.addEventListener('click', function (event) {

		//if the clicked element is the refine accordion
		if(event.target.classList.contains('refine-group')) {
			event.target.classList.toggle('active');

			event.target.classList.contains("active")
			? (event.target.ariaExpanded = "true")
			: (event.target.ariaExpanded = "false");
		}
	});

	document.addEventListener('click', function (event) {
		//if the clicked element is a refinement toggle
		if(event.target.matches('.refine-toggle')) {

			//show the loader
			toggle_loader();
		}
	});

    //attempt to find our refine sidebar
    let refine_sidebar = document.querySelector('#refine-sidebar');

    //if the sidebar exists
    if(refine_sidebar) {

        //fetch the purchase bar as we need to account for it in its desktop sticky state
        let purchase_sidebar = document.querySelector('#purchase-sidebar');

        //fetch the admin bar (if it exists)
        let admin_bar = document.getElementById('wpadminbar');

        //fetch the grid element
        let grid = refine_sidebar.nextElementSibling;

        //check to see if this is a page with no results
        let no_results = document.querySelector('#no-results-found');

        //if there are no results or less than 10 results
        if(no_results || grid.dataset.results <= 9) {

            //bail
            return;
        }

        //defines our initial and end positions
        let initial_pos;
        let end_pos;

        //get the initial positions of the elements
        function get_sidebar_positions() {

            //check to see if we need to apply the sticky class
            let media_query = window.matchMedia('(min-width: 1280px)').matches;

            //if the screen is too small, we don't need to do anything here
            if(!media_query) {

                //bail
                return;
            }

            //remove the sticky class from the element
            refine_sidebar.classList.remove('sticky-refine');

            //reset the height of the element
            refine_sidebar.style.height = '100%';
            refine_sidebar.style.bottom = '';

            //get the initial position of the element
            initial_pos = (refine_sidebar.getBoundingClientRect().top + window.pageYOffset - purchase_sidebar.offsetHeight) - (admin_bar ? admin_bar.offsetHeight : 0) - 10;

            //calculate the point where the sidebar should stop sticking and move upwards
            end_pos = (grid.getBoundingClientRect().bottom - window.innerHeight) - 10;

            //check to see if the sidebar should be sticky
            check_sidebar_position();
        }

        //check to see if the sidebar should be sticky
        function check_sidebar_position() {

            //check to see if we need to apply the sticky class
            let media_query = window.matchMedia('(min-width: 1280px)').matches;

            //if the screen is the right size and the user has scrolled past the initial position of the element
            if (media_query && window.pageYOffset >= initial_pos) {

                //add the sticky class to the element
                refine_sidebar.classList.add('sticky-refine');

                //set the height of the element to match the viewport
                refine_sidebar.style.height = 'calc(100% - ' + ((purchase_sidebar.offsetHeight + (admin_bar ? admin_bar.offsetHeight : 0)) + 20) + 'px)';

                //if the user has scrolled past the end position of the element
                if(window.pageYOffset > end_pos) {

                    //set the bottom position of the element to match the viewport
                    refine_sidebar.style.bottom = (pageYOffset - end_pos) + 'px';
                } else { //otherwise it's still within the grid

                    //reset the bottom position of the element
                    refine_sidebar.style.bottom = '';
                }
            } else { //otherwise the user is at the top of the page or above the initial position

                //remove the sticky class from the element
                refine_sidebar.classList.remove('sticky-refine');

                //reset the height of the element
                refine_sidebar.style.height = '100%';
                refine_sidebar.style.bottom = '';
            }
        }

        //add scroll event listener
        window.addEventListener('scroll', check_sidebar_position);

        //add resize event listener to refresh positions
        window.addEventListener('resize', () => {

            //wait for the window to finish resizing...
            setTimeout(() => {
                get_sidebar_positions();
            }, 250);
        });

        //get the initial positions of the elements
        get_sidebar_positions();
    }
});